import { Request } from "../services/Requests";

import { SearchResult } from "../datatypes/SearchResult";

const RequestBuilder = new Request.Builder("searchdiscover", "articlesearch").withManualBaseUrl(
    "/searchdiscover/articlesearch"
);

export type FavouriteSearchQuery = {
    query: string;
    country: string;
    language: string;
    storeId: string;
    customerId?: string | null | undefined;
    page?: number | null | undefined;
    rows?: number | null | undefined;
    favouritesPage?: number | null | undefined;
    amountOfFavourites?: number | null | undefined;
    restriction?: string | null | undefined;
    sorting?: string | null | undefined;
    profile?: string | null | undefined;
    debugQuery?: boolean | null | undefined;
    onlySearchable?: boolean | null | undefined;
    filter?: string[] | null | undefined;
    facets?: boolean | null | undefined;
    categories?: boolean | null | undefined;
};

export type FavouriteSearchResult = {
    regularResults: SearchResult;
    favourites: SearchResult;
};

const service = {
    getRestrictions(ids: Array<string>) {
        const url = "/restriction";
        return RequestBuilder.path(url, {})
            .body({ ids })
            .retry()
            .post();
    },

    doSearch(query: { [x: string]: any }) {
        const url = "/search";
        return RequestBuilder.path(url, {})
            .query(query)
            .retry()
            .get();
    },

    doSimpleSearch(query: { [x: string]: any }) {
        const url = "/simpleSearch";
        return RequestBuilder.path(url, {})
            .query(query)
            .retry()
            .get();
    }
};

export default service;
